import Eventemitter3 from "eventemitter3";

const events = new Eventemitter3();
export default events;
